import PrivateRoute, { Router } from "@Components/app-layout/PrivateRoute";

import TokensGrid from "../components/Grid";
import { TokenProvider } from "../store";

import TokenFormLayout from "./Form";

export default function TokensGridLayout() {
  return <TokenProvider>
    <TokensGrid />
    <Router>
      <PrivateRoute path={["/admin/tokens/add", "/admin/tokens/:id"]} component={TokenFormLayout} />
    </Router>
  </TokenProvider>
}
